export default "__VITE_ASSET__v$A2iuJ3__"